// extracted by mini-css-extract-plugin
export default {"ctaListWrapper":"NewTalentProfile_ctaListWrapper__UiAxD","offerListContainer":"NewTalentProfile_offerListContainer__o2Pg1","ctasContainer":"NewTalentProfile_ctasContainer__s5NZS"};